<div class="ui-dashboard" >

  <div class="dashboard-wrapper">

    <!-- Heading & Dates -->
    <div class="p-b-10">
      <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">

        <!-- LHS -->
        <div>
          <h2 class="dashboard-head">Underwriter Dashboard</h2>
          <p class="dashboard-head-sub">
            <nz-avatar style="color:#f56a00; background-color:#fde3cf; line-height: 0.5"
              [nzSrc]="'https://randomuser.me/api/portraits/men/73.jpg'" nzSize="small" nzIcon="user">
            </nz-avatar>
            <strong class="p-l-10 p-r-5 d-i-b">Welcome back, John!</strong> 
        </div>
      </div>


      <!-- underwriter screen board -->
      <div class="grid" style="margin-top: 15px;" class="widget widget-shadow">
        <div class="flexie-auto-grid">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Underwriter Screen board</h3>
          </div>
          <div class="text-a-right">
            <nz-range-picker [(ngModel)]="dashboardDateRange" class="dash-date-range"
              [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
            </nz-range-picker>
          </div>
        </div>

        <div>
          <nz-table #basicTable [nzData]="underwriterBoard" [nzShowPagination]="false" class="d-b">
            <thead>
              <tr>
                <th scope="col">Key</th>
                <th scope="col">Total Cases</th>
                <th scope="col">STP Cases</th>
                <th scope="col">NSTP Cases</th>
                <th scope="col">Pending Cases</th>
                <th scope="col">Rated Cases</th>
                <th scope="col">Declined Cases</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of basicTable.data">
                <td>{{u.LOB}}</td>
                <td>{{u.totalCases}}</td>
                <td>{{u.STP}} ({{calculateAndGetPercentage(u.STP, u.totalCases)}}%)</td>
                <td>{{u.NSTP}} ({{calculateAndGetPercentage(u.NSTP, u.totalCases)}}%)</td>
                <td>{{u.pending}} ({{calculateAndGetPercentage(u.pending, u.totalCases)}}%)</td>
                <td>{{u.rated}} ({{calculateAndGetPercentage(u.rated, u.totalCases)}}%)</td>
                <td>{{u.declined}} ({{calculateAndGetPercentage(u.declined, u.totalCases)}}%)</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>


      <!-- Product and LOB wise Analysis -->
      <div class="grid" style="margin-top: 1.5em;" class="widget widget-shadow">
        <div class="flexie-auto-grid">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Product and LOB wise Analysis</h3>
          </div>
          <div class="text-a-right">
            <nz-range-picker [(ngModel)]="dashboardDateRange" class="dash-date-range"
              [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
            </nz-range-picker>
          </div>
        </div>
        <div>
          <nz-table #analysisTable [nzData]="productLobAnalysis" [nzShowPagination]="false" class="d-b">
            <thead>
              <tr>
                <th scope="col">LOB</th>
                <th scope="col">Product</th>
                <th scope="col">Product ID</th>
                <th scope="col">Issued Policy Ratio</th>
                <th scope="col">Referred Policy Ratio</th>
                <th scope="col">Rejected Policy Ratio</th>
                <th scope="col">SLA Breaching Ratio</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let u of analysisTable.data">
                <td>{{u.LOB}}</td>
                <td>{{u.product}}</td>
                <td>{{u.productID}}</td>
                <td>{{u.issuedPolicyRatio}}%</td>
                <td>{{u.referredPolicyRatio}}%</td>
                <td>{{u.rejectedPolicyRatio}}%</td>
                <td>{{u.SLABreachingRatio}}%</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>

      <!-- STP Vs NSTP -->

      <div style="margin-top: 1.5em; font-size: 18px; margin-bottom: 4.5em;" class="widget widget-shadow">

        <div class="flexie-auto-grid">
          <div>
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">STP  Vs  NSTP</h3>
          </div>
          <div class="text-a-right">
          </div>
        </div>


        <div class="flex">
          <ngx-charts-line-chart [view]="[1200,350]" [results]="chart" [xAxisLabel]="'month'" [yAxisLabel]="'range'"
            [legend]="true" [scheme]="colorScheme" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true"
            [yAxis]="true" [timeline]="true">
          </ngx-charts-line-chart>
        </div>
      </div>



      <!-- flex css -->

      <div class="chartflex ">
        <!-- Age Group Chart -->
        <div class="widget widget-shadow chart2">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Case By Age Group</h3>
          </div>
          <ngx-charts-pie-chart [view]="[450, 250]" [scheme]="colorScheme" [results]="ageGroupChart"
            [legend]="ageGroupShowLegend" [legendPosition]="legendPosition">
          </ngx-charts-pie-chart>
          <!-- <ngx-charts-pie-chart [view]="[450, 250]" [scheme]="colorScheme" [results]="ageGroupChart"
              [gradient]="ageGroupGradient" [legend]="ageGroupShowLegend" [legendPosition]="legendPosition"
              [labels]="ageGroupShowLabels" [doughnut]="isDoughnut">
            </ngx-charts-pie-chart> -->
        </div>

        <!-- Decline Reason Chart -->
        <div class="widget widget-shadow chart2">
          <div style="text-align: start;">
            <div style="font-size: 18px;">
              <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
              <h3 class="d-i-b m-l-10">Reasons For Decline</h3>
            </div>
            <ngx-charts-pie-chart [view]="[450, 250]" [scheme]="colorScheme" [results]="declineReasonChart"
              [legend]="ageGroupShowLegend" [legendPosition]="legendPosition">
            </ngx-charts-pie-chart>
          </div>
        </div>
      </div>


        



      <!-- Product wise Top 10 fail rules -->
      <div class="grid" class="widget widget-shadow" style="margin-top: 1.5em;">

        <div style="font-size: 18px;">
          <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
          <h3 class="d-i-b m-l-10">Product Wise Top 10 Failed Rules</h3>
        </div>

        <div>
          <nz-table #ruleTable [nzData]="ruleTableData" [nzShowPagination]="false" class="d-b">
            <thead>
              <tr>

                <th scope="col">Product Name</th>
                <th scope="col">Product ID</th>
                <th scope="col">Rule Name</th>
                <th scope="col">Failing Ratio</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let i of ruleTable.data">

                <td>{{i.productName}}</td>
                <td>{{i.productID}}</td>
                <td>{{i.ruleName}}</td>
                <td>{{i.failingRatio}}%</td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>



      <!-- Assigned task -->
      <div class="grid" class="widget widget-shadow" style="margin-top: 1.5em">

        <div style="font-size: 18px; margin-bottom: 20px;">
          <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
          <h3 class="d-i-b m-l-10">Assigned Task</h3>
        </div>
        <nz-timeline class="timeline">
          <nz-timeline-item nzType="horizontal" class="item" *ngFor="let item of timelineData; let i = index">
            <h4>{{ item.title }}</h4>
            <p>{{ item.description }}</p>
            <div class="progress-bar-container">
              <div class="progress-bar" [style.width.%]="item.progress" [style.backgroundColor]="item.color"></div>
            </div>
          </nz-timeline-item>
        </nz-timeline>
      </div>



      <!-- Monthly SLA and Employee of month -->

      <div class="chart">
        <!-- Monthly Report of SLA -->
        <div class="widget widget-shadow sla-css">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Monthly Report of SLA</h3>
          </div>
          <ngx-charts-pie-chart [view]="[350, 250]" [scheme]="colorScheme" [results]="slaData"
            [legend]="ageGroupShowLegend" [legendPosition]="legendPosition">
          </ngx-charts-pie-chart>
        </div>

        <!-- Employee of the Month -->
        <div class="widget widget-shadow sla-css">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Employee of the Month ({{ currentMonth }})</h3>
          </div>
          <nz-list>
            <nz-list-item *ngFor="let item of items">
              <nz-list-item-meta [nzAvatar]="usericon" [nzTitle]="item.text"></nz-list-item-meta>
              <ng-template #usericon>
                <i nz-icon nzType="user" nzTheme="outline" class="rounded-icon"></i>
              </ng-template>
            </nz-list-item>
          </nz-list>
        </div>
      </div>



      <!-- Top 5 reasons of missing SLA-->

      <div class="chart">
        <!-- Top 5 reasons of missing SLA -->
        <div class="widget widget-shadow sla-css">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Top 5 reasons of missing SLA</h3>
          </div>
          <ngx-charts-pie-chart [view]="[350, 250]" [scheme]="colorScheme" [results]="slaData"
            [legend]="ageGroupShowLegend" [legendPosition]="legendPosition">
          </ngx-charts-pie-chart>
        </div>

        <!-- Top 5 Employee with most missed SLA -->
        <div class="widget widget-shadow sla-css">
          <div style="font-size: 18px;">
            <i nz-icon nzType="file-text" nzTheme="outline" class="m-r-5"></i>
            <h3 class="d-i-b m-l-10">Top 5 Employee with most missed SLA</h3>
          </div>
          <nz-list>
            <nz-list-item *ngFor="let item of items">
              <nz-list-item-meta [nzAvatar]="usericon" [nzTitle]="item.text"></nz-list-item-meta>
              <ng-template #usericon>
                <i nz-icon nzType="user" nzTheme="outline" class="rounded-icon"></i>
              </ng-template>
            </nz-list-item>
          </nz-list>
        </div>
      </div>
    </div>
  </div>
</div>